module.exports = __webpack_public_path__ + "img/logo.718694e2.png";